export var MODAL_TYPE = {
    STREAM_IFRAMLESS_MODAL: 'streamIframlessModal',
};
